import { render, staticRenderFns } from "./TasksManagement.vue?vue&type=template&id=36df4840&scoped=true"
import script from "./TasksManagement.vue?vue&type=script&lang=js"
export * from "./TasksManagement.vue?vue&type=script&lang=js"
import style0 from "./TasksManagement.vue?vue&type=style&index=0&id=36df4840&prod&scoped=true&lang=css"
import style1 from "./TasksManagement.vue?vue&type=style&index=1&id=36df4840&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df4840",
  null
  
)

export default component.exports